import React, { useContext } from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import {
  GET_COMPETITION,
  COMPETITIONS_WITH_PERMISSION,
} from "../../GraphQL/Competitions.js";
import CompetitionOverview from "../../Components/Competition/CompetitionOverview.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import SeasonsTable from "../../Components/Season/SeasonsTable.js";
import {
  GET_SEASONS_BY_COMPETITION_ID,
  SEASONS_WITH_PERMISSION,
} from "../../GraphQL/Season.js";
import { LoginContext } from "../../Components/Login/LoginContext";
import { Typography } from "@mui/material";
import NewSeasonButton from "../../Components/Season/NewSeasonButton.js";

const CompetitionPage = () => {
  const { competitionId } = useParams();

  const competition = useQuery(GET_COMPETITION, {
    variables: { id: competitionId },
  });

  const seasons = useQuery(GET_SEASONS_BY_COMPETITION_ID, {
    variables: { id: competitionId },
  });

  const seasonsWithPermission = useQuery(SEASONS_WITH_PERMISSION, {});

  const competitionsWithPermission = useQuery(COMPETITIONS_WITH_PERMISSION, {});

  const [auth] = useContext(LoginContext);

  const queryError =
    competition.error ||
    seasons.error ||
    seasonsWithPermission.error ||
    competitionsWithPermission.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          competition.refetch();
          seasons.refetch();
          seasonsWithPermission.refetch();
          competitionsWithPermission.refetch();
        }}
      />
    );
  }

  if (
    competition.loading ||
    seasons.loading ||
    seasonsWithPermission.loading ||
    competitionsWithPermission.loading
  )
    return <LoadingSpinner />;

  const canEdit =
    auth.loggedIn &&
    competitionsWithPermission.data.competitionsWithPermission.some(
      (c) => String(c.id) === String(competitionId)
    );

  return (
    <PageLayout
      title={competition.data.competition.name}
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Competitions", to: "/competitions" },
        { label: competition.data.competition.name },
      ]}
      actions={canEdit && <NewSeasonButton competitionId={competitionId} />}
    >
      <CompetitionOverview competition={competition.data.competition} />
      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Seasons</Typography>
      <SeasonsTable
        seasonsWithPermission={seasonsWithPermission.data.seasonsWithPermission}
        seasons={seasons.data.seasonsByCompetitionId}
        canEdit={canEdit}
        competitionId={competitionId}
      />
    </PageLayout>
  );
};

export default CompetitionPage;
